// src/store/index.js
import { createStore } from 'vuex';
import downloadModule from './modules/download';
import caseModule from './modules/case';
import userModule from './modules/user';
import adminModule from './modules/admin';

export default createStore({
  modules: {
    download: downloadModule,
    case: caseModule,
    user: userModule,
    admin: adminModule
  }
});
